export default class Diseases {
  disease_list = []
}
